import _ from 'lodash';
import api from 'networkapp-api-connector';
import moment from 'moment';

import generateThumbnail from '../misc/generateThumbnail';
import srcToFile from '../misc/srcToFile';

export default {
    programItemSelection: function (eventId, programItem, select) {
        select || (select = false);

        return api.events.programItemSelection(programItem, select).then((data) => {
            app.store.dispatch(app.actions.program.updateProgramSelection(eventId, data.selected_ids, data.deselected, data.program_item));
            return data;
        });
    },
    rateProgramItem: function (eventId, programId, rating) {
        return api.events.rateProgramItem(programId, rating).then((data) => {
            app.store.dispatch(app.actions.program.updateProgramItem(eventId, programId, data));
            return data;
        });
    },
    fetchUserEvents: function (userId) {
        if (!userId) userId = app.store.getState().session.user.id;

        return api.events.fetchUserEvents(userId).then(function (data) {
            app.store.dispatch(app.actions.events.loadUserEvents(_.map(data.result, 'event'), moment.utc(data.fetch_time).toISOString()));
            app.store.dispatch(data.result.map((event) => app.actions.events.updateUserEvent(event.event_id, event)));
        });
    },
    fetchEvent: function (eventId) {
        let userId = app.store.getState().session.user.id;
        return api.events.fetchEvent(userId, eventId).then(function (data) {
            app.store.dispatch(app.actions.events.updateEvents(data.event, moment.utc(data.fetch_time).toISOString()));
            return data.event;
        });
    },
    addEvent: function (code) {
        var userId = app.store.getState().session.user.id;
        return api.events
            .addEvent(userId, code)
            .then(function (data) {
                if (data.event) {
                    app.store.dispatch(app.actions.events.updateEvents([data.event], data.answer_time));
                }
                if (data.participant && (data.participant.exact_match || data.participant.fuzzy_matches.length)) {
                    app.store.dispatch(app.actions.participants.needsDisambiguation(data.event_id ?? data.event.id, data.participant));
                }
                return data;
            })
            .then((data) => app.api.session.getUpdates().then(() => data));
    },
    joinEvent: function (eventId) {
        let userId = app.store.getState().session.user.id;
        return api.events.joinEvent(userId, eventId).then((data) => {
            const changes = [];

            if (data.parent) {
                changes.push(app.actions.events.singleEventUpdate(data.parent, data.date_created));
            }
            if (data.event) {
                changes.push(app.actions.events.singleEventUpdate(data.event, data.date_created));
            }
            if (data.participant && (data.participant.exact_match || data.participant.fuzzy_matches.length)) {
                changes.push(app.actions.participants.needsDisambiguation(eventId, data.participant));
            }
            app.store.dispatch(changes);

            return data.event;
        });
        // .then(data => app.api.session.getUpdates().then(() => data));
    },
    leaveEvent: function (eventId) {
        let userId = app.store.getState().session.user.id;
        return api.events
            .leaveEvent(userId, eventId)
            .then((data) => {
                const changes = [];

                if (data.parent) {
                    changes.push(app.actions.events.singleEventUpdate(data.parent, data.date_created));
                }
                if (data.event) {
                    changes.push(app.actions.events.singleEventUpdate(data.event, data.date_created));
                }

                app.store.dispatch(changes);
            })
            .catch((e) => {
                console.error(e);
            });
        // .then(data => app.api.session.getUpdates().then(() => data));
    },
    deleteFromEvent: function (eventId) {
        let userId = app.store.getState().session.user.id;
        return api.events.deleteFromEvent(userId, eventId).then((data) => {
            app.store.dispatch(app.actions.events.deleteEvent(eventId));
        });
    },
    fetchEnrichments: function (eventId) {
        return api.events.fetchEnrichments(eventId).then((answer) => {
            app.store.dispatch(app.actions.enrichments.loadEnrichmentData(eventId, answer.result, moment.utc(answer.fetch_time).toISOString()));
        });
    },
    fetchParticipants: function (eventId) {
        return api.events.fetchParticipants(eventId).then((data) => {
            app.store.dispatch(
                app.actions.participants.loadEventParticipants(eventId, data.result, moment.utc(data.fetch_time).toISOString(), data.category_values, data.categories, data.recommended_filter)
            );
        });
    },
    fetchProgram: function (eventId) {
        return api.events.fetchProgram(eventId).then((data) => {
            app.store.dispatch(app.actions.program.loadEventProgram(eventId, data.result, data.categories, moment.utc(data.fetch_time).toISOString(), data.recommended_filter));
        });
    },
    fetchSpeakers: function (eventId) {
        return api.events.fetchSpeakers(eventId).then((answer) => {
            app.store.dispatch(app.actions.speakers.loadEventSpeakers(eventId, answer.result));
        });
    },
    fetchNews: function (eventId) {
        return api.events.fetchNews(eventId).then((answer) => {
            app.store.dispatch(app.actions.news.loadEventNews(eventId, answer.result, moment.utc(answer.fetch_time).toISOString()));
        });
    },
    fetchDirectoryItem: function (eventId, itemId) {
        return api.events.fetchDirectoryItem(eventId, itemId).then((data) => {
            app.store.dispatch(app.actions.directory.updateDirectoryData(eventId, data.id, [data], moment()));
        });
    },
    fetchExhibitors: function (eventId) {
        return api.events.fetchExhibitors(eventId).then((data) => {
            app.store.dispatch(app.actions.exhibitors.setFilterParams(eventId, data.tags, data.recommended_filter));
            app.store.dispatch(app.actions.directory.updateDirectoryData(eventId, null, data.result, moment.utc(data.fetch_time).toISOString()));
        });
    },
    fetchDirectory: function (eventId, directoryId) {
        return api.events.fetchExhibitors(eventId, directoryId).then((data) => {
            app.store.dispatch(app.actions.directoryTags.updateDirectoryTags(eventId, directoryId, data.tags));
            app.store.dispatch(app.actions.directory.updateDirectoryData(eventId, directoryId, data.result));
        });
    },
    saveEnrichmentAnswer: function (eventId, enrichmentQuestionId, answer) {
        return api.events.saveEnrichmentAnswer(eventId, enrichmentQuestionId, answer).then((questionData) => {
            app.store.dispatch(app.actions.enrichments.updateAnswer(eventId, questionData));
        });
    },
    alias: function (eventId, participantId) {
        return api.events.alias(eventId, participantId);
    },
    fetchLocations: function (eventId) {
        return api.events.fetchLocations(eventId).then((response) => {
            app.store.dispatch(app.actions.locations.updateEventLocations(eventId, response.result, moment.utc(response.fetch_time).toISOString()));
        });
    },
    sendMessageToSponsor: function (senderId, sponsorId, subject, message) {
        return api.events.sendMessageToSponsor(senderId, sponsorId, subject, message);
    },
    fetchMeetings: function (eventId) {
        var userId = app.store.getState().session.user.id;
        return api.users.fetchMeetings(userId, eventId).then((answer) => {
            app.store.dispatch(app.actions.meetings.loadEventMeetings(eventId, answer.organized, answer.result, moment.utc(answer.fetch_time).toISOString()));
        });
    },
    connections: function (eventId) {
        return api.events.connections(eventId).then((answer) => {
            app.store.dispatch(app.actions.connections.updateEventConnections(eventId, answer.result, moment.utc(answer.fetch_time).toISOString()));
        });
    },
    poke: function (eventId, participantId, message) {
        return api.events.poke(eventId, participantId, message).then((data) => {
            if (data.sent == 'yes') {
                app.store.dispatch(app.actions.participants.poked(eventId, participantId));
            }
            return data;
        });
    },
    uploadUserEventFile: function (eventId, file) {
        return api.uploads.sendEventObject(eventId, file).then((uid) => {
            // if uploaded file is a video, lets generate a thumbnail and upload that too
            if (file.type.match(/^video\//)) {
                return generateThumbnail(URL.createObjectURL(file))
                    .then((dataURL) => {
                        let file = srcToFile(dataURL);
                        return api.uploads.sendEventObject(eventId, file, uid + '_thumbnail', true);
                    })
                    .then(() => uid);
            }
            return uid;
        });
    },
    performAction: function (eventId, type, data) {
        return api.events.performAction(eventId, type, data);
    },
};
